import { Provider } from '@angular/core';
import { SecurityAuthenticationViewContractId as Provide } from '@daas-consulting/security/authentication/frontend/view_contracts';
import { AuthenticationViewModel as Value } from '@daas-consulting/security/authentication/frontend/view_models';

export const AuthenticationViewModelProvider: Provider = {
  provide: Provide,
  useClass: Value,
};
